<template>
    <div class="main">
        <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Replenishment</h3>
            </div>
            <div style="display:flex;justify-content: flex-end;margin-bottom: 20px;">

                <a-button @click="showAddInventoryTransferModal"
                    style="height:38px;margin-right: 10px;border-raduis:5px; background: #418a49; color:#fff;"
                    icon="plus">
                    Add Replenishment Request
                </a-button>
                <!-- <a-button @click="exportStockData" style="height:38px;border-raduis:5px; background: #418a49; color:#fff;" icon="export">
                    Export
                </a-button> -->
            </div>
            <div>
                <a-table :columns="columns" :data-source="tableInventoryTransfers" :loading='tableLoading'
                    :pagination="pagination" class="tableStyle">
                    <div slot="filterDropdown"
                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                        style="padding: 8px">
                        <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                            Search
                        </a-button>
                        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                            Reset
                        </a-button>
                    </div>
                    <div slot="filterStatusDropdown" slot-scope="{ clearFilters }"
                        style="padding: 8px;display: flex;flex-direction: column;">
                        <a-select style="width: 190px" @change="e => onInventoryChange(e, clearFilters)">
                            <a-select-option value="all">
                                All
                            </a-select-option>
                            <a-select-option value="0">
                                New
                            </a-select-option>
                            <a-select-option value="1">
                                AwaitingFulfillment
                            </a-select-option>
                            <a-select-option value="2">
                                Fulfilling
                            </a-select-option>
                            <a-select-option value="3">
                                Complete
                            </a-select-option>
                            <a-select-option value="4">
                                Canceled
                            </a-select-option>
                            <a-select-option value="5">
                                Received
                            </a-select-option>
                        </a-select>
                    </div>
                    <template slot="action" slot-scope="data">
                        <a-dropdown>
                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-icon style="font-size:25px;" type="ellipsis" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item>
                                    <a @click="showTransfersLines(data)">View More?</a>
                                </a-menu-item>
                                <a-menu-item v-show="data.status === 0">
                                    <a @click="handleConfirm(data)">Confirm Request</a>
                                </a-menu-item>

                            </a-menu>
                        </a-dropdown>
                    </template>

                    <template slot="status" slot-scope="data">
                        <status-component v-if="data" :status="data"></status-component>
                    </template>
                    <template slot="typeLabel" slot-scope='data'>
                        <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #ddf1dd;width: 140px;height: 27px;border-radius: 30px"
                            v-if="data === `Returned`">
                            <!-- <p style="width: 9px;height: 9px;background: #2ca62d;margin-top: 5px;border-radius:50%"></p> -->
                            <p style="font-size:12px;color:#2ca62d;"> {{ data }}</p>
                        </div>
                        <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 140px;height: 27px;border-radius: 30px"
                            v-if="data === `TransferredOut`">
                            <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
                            <p style="font-size:12px;color:#ffb102;"> {{ data }}</p>
                        </div>
                        <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #d1edfc;width: 140px;height: 27px;border-radius: 30px"
                            v-if="data === `Lost`">
                            <!-- <p style="width: 9px;height: 9px;background: #41c4fd;margin-top: 5px;border-radius:50%"></p> -->
                            <p style="font-size:12px;color:#41c4fd;"> {{ data }}</p>
                        </div>

                        <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #ff000073;width: 140px;height: 27px;border-radius: 30px"
                            v-if="data === `Damaged`">
                            <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
                            <p style="font-size:12px;color:#fff;">{{ data }}</p>
                        </div>
                        <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #0096889e;width: 140px;height: 27px;border-radius: 30px"
                            v-if="data === `TransferredIn`">
                            <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
                            <p style="font-size:12px;color:#fff;">{{ data }}</p>
                        </div>

                    </template>

                </a-table>
            </div>
            <a-modal class="modalStyle" :visible="addInventoryTransferVisible" width="800px" :footer="null"
                @cancel="handleAddInventoryTransferCancel">
                <a-spin :spinning="loading">
                    <h3
                        style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;padding-bottom:30px">
                        Add Replenishment Request</h3>
                    <div>
                        <a-form-model ref="addInventoryTransferForm" :model="addInventoryTransferModel" :rules="rules">
                            <a-row>
                                <a-col :span="11" :offset="1">
                                    <a-form-model-item label="Transfer From" ref="sourceLocationId"
                                        prop="sourceLocationId">
                                        <a-select @change="onChangeSourceLocation"
                                            v-model="addInventoryTransferModel.sourceLocationId"
                                            placeholder="please select your option">
                                            <a-select-option v-for="center in availableDistCenters"
                                                :key="center.locationId" v-bind:value="center.locationId">
                                                {{ center.name }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="11" :offset="1">
                                    <a-form-model-item label="Transfer To" ref="distributionCenterId"
                                        prop="distributionCenterId">
                                        <a-select v-model="addInventoryTransferModel.distributionCenterId"
                                            placeholder="please select your option">
                                            <a-select-option v-for="center in availableDistCenters" :key="center.id"
                                                v-bind:value="center.id">
                                                {{ center.name }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <div ref="productHeight" style="height: 200px; overflow-y: scroll">
                                <a-row v-for="(request, index) in addInventoryTransferModel.request" :key="request.key"
                                    type="flex" justify="space-around">
                                    <a-col :span="11">
                                        <a-form-model-item label="Product Name"
                                            :prop="'request.' + index + '.productId'" :rules="{
                            required: true,
                            message: 'Please choose your option',
                            trigger: 'change',
                        }">
                                            <a-select @change="(e) => onChangeProduct(request, e)" show-search
                                                placeholder="Choose your product" option-filter-prop="children"
                                                v-model="request.productId" :filter-option="filterOption">
                                                <a-select-option v-for="product in filteredProducts"
                                                    :key="product.productId" v-bind:value="product.productId">
                                                    {{product.productBrandName}}
                                                </a-select-option>
                                            </a-select>

                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="3">
                                        <a-form-model-item label="Quantity" :prop="'request.' + index + '.quantity'"
                                            :rules="[
                            {
                                required: true,
                                message: 'Please enter your quantity',
                                trigger: 'change',
                            },
                            
                        ]">
                                            <a-input-number :min="1" :max="request.balance" class="rightSideinputText"
                                                type="number" @change="(e) => onChangeQuantity(request, e)"
                                                v-model="request.quantity" />
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="4">
                                        <div style="margin-top: 53px;display:flex;justify-content: space-around">
                                            <a-icon v-if="addInventoryTransferModel.request.length > 1"
                                                class="dynamic-delete-button" type="minus-circle-o"
                                                :disabled="addInventoryTransferModel.request.length === 1"
                                                @click="removeDomain(request)" />
                                        </div>
                                    </a-col>

                                </a-row>
                            </div>

                            <a-form-model-item class="pt-4">
                                <a-button :disabled="filteredProducts.length === 0"
                                    style="margin:0 auto;float: right; background:#418a49; color:#fff;"
                                    @click="addDomain">
                                    <a-icon type="plus" /> Add Product
                                </a-button>
                            </a-form-model-item>
                            <a-row>
                                <a-col :span="22" :offset="1">
                                    <a-form-model-item label="Notes" ref="notes" prop="notes">
                                        <a-textarea v-model="addInventoryTransferModel.notes"
                                            placeholder="Enter notes...." :auto-size="{ minRows: 3, maxRows: 5 }" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>

                            <a-form-model-item
                                style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                                <a-button :loading="loading" @click="handleAddInventoryTransfer"
                                    style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                    Add Replenishment Request
                                </a-button>
                            </a-form-model-item>

                        </a-form-model>
                    </div>
                </a-spin>


            </a-modal>
            <a-modal :visible="showConfirmModal" width="500px" :footer="null" title="Confirm Inventory Request"
                @cancel="handleCancelRequest">
                <a-form>
                    <a-form-item label="Notes:">
                        <a-textarea v-model="reasons" placeholder="Notes..."></a-textarea>
                    </a-form-item>
                </a-form>
                <a-row type="flex" justify="space-between">
                    <a-button type="primary" style="background: #418a49; color: #fff" @click="confirmAction">Confirm
                    </a-button>
                    <a-button style="background: #df2b0e; border: 1px solid #df2b0e; color: #fff"
                        @click="handleCancelRequest">Cancel</a-button>
                </a-row>
            </a-modal>
            <a-modal :visible="confirmActionModal" width="500px" :footer="null" title="Confirm Action"
                @cancel="cancelAction">
                <a-spin :spinning="loading">
                    <p :style="{ color: '#b3b3b3', textAlign: 'center', fontSize: '20px' }">
                        Are you sure about this !!!
                    </p>
                    <a-row type="flex" justify="space-between">
                        <a-button type="primary" style="background: #418a49; color: #fff" @click="handleConfirmRequest">
                            Confirm</a-button>
                        <a-button style="background: #df2b0e; border: 1px solid #df2b0e; color: #fff"
                            @click="cancelAction">
                            Cancel</a-button>
                    </a-row>
                </a-spin>
            </a-modal>
        </a-card>
    </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import XLSX from "xlsx";
// import _ from 'lodash';
import StatusComponent from '../shared-components/StatusComponent.vue'
import { NotificationMixins } from '../../mixins/NotificationMixins'

const columns = [
{
    title: "Id",
    // width: 150,
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: 'Source',
    dataIndex: 'sourceLocationName',
    // width: 130,
  },
  {
    title: 'Destination',
    dataIndex: 'destinationLocationName',
    scopedSlots: {
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
        record.destinationLocationName
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
    // width: 130,
  },
 
  {
    title: 'Status',
    dataIndex: 'status',
    scopedSlots: {
    customRender: "status",
    filterDropdown: 'filterStatusDropdown',
    filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
        record.status
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
  },
  {
    title: 'Date Created',
    dataIndex: 'createdAt',
    key: "createdAt",
  },
  {
    title: 'Action',
    dataIndex: 'action',
    // width: 150,
    scopedSlots: { customRender: 'action' }
  }
];

    export default {
        name: 'InventoryTransfer',
        components:{
            StatusComponent
        },
        mixins: [ NotificationMixins ],
        data(){
            return{
                tableInventoryTransfers: [],
                availableProducts:[],
                filteredProducts:[],
                availableDistCenters:[],
                availableTransfers:[],
                tableLoading: false,
                columns,
                pagination: {
                    pageSize:20
                },
                params:{
                    page: -1,
                    perPage:-1,
                    searchBy: {},
                    sortBy: {}
                },
                addInventoryTransferModel:{
                    request:[
                        {
                            productId:'',
                            quantity: '',
                            balance: 0,
                            key: Date.now()
                        }
                    ],
                    notes: '',
                    distributionCenterId: '',
                    sourceLocationId: ''
                },
                editUserModel: {
                    name: '',
                    phoneNumber:'',
                    gender:''
				},
                changePassswordModel:{
                    newPassword: '',
                    confirmPassword: ''
                },
                selectedUser: {},
                searchText: '',
                searchInput: null,
                searchedColumn: '',
                selectedProduct: {},
                addInventoryTransferVisible: false,
                editUserVisible: false,
                disableUserVisible: false,
                changePasswordVisible: false,
                dateFormat: 'DD/MM/YYYY',
                startDate: moment(),
                endDate: moment(),
                loading: false,
                showConfirmModal: false,
                confirmActionModal: false,
                currentRequest: {},
                reasons:"",
                rules: {
                    locationId: [
                        { required: true, message: 'Please select your option' , trigger: 'change'},
                    ],
                    type: [
                        { required: true, message: 'Please select your option', trigger: 'change' }
                    ],
                    productId: [
                        { required: true, message: 'Please select your option', trigger: 'change' }
                    ],
                    quantity: [
                        { required: true, message: 'Please enter your quantity', trigger: 'change' },
                        {
                                pattern: new RegExp(/^[1-9]\d*$/),
                                message: 'Please enter valid number',
                                trigger: 'change'
                        },
                    ],
                    sourceLocationId: [
                        { required: true, message: 'Choose where you will be transfering products from', trigger: 'change' }
                    ],
                    distributionCenterId: [
                        { required: true, message: 'Please select where your products will be transfered to', trigger: 'change' }
                    ],
                },
            }
        },
        computed:{
            ...mapGetters(['IsAgentProfileAvailable']),
        },
        methods:{
          ...mapActions(['getInventoryBalByDistCenter','getAllDistributionCenters','addInventoryTransfer','updateStockAdjustment','getWareHousTransferData','setWareHouseTransferLinesInfo']),
          onChange(date, dateString) {
                // console.log(date, dateString);
                this.startDate = dateString[0];
                this.endDate = dateString[1];
                // console.log("startDate | ", this.startDate);
                // console.log("endDate | ", this.endDate);
            },
            moment,
            handleSearch(selectedKeys, confirm, dataIndex) {
                confirm();
                this.searchText = selectedKeys[0];
                this.searchedColumn = dataIndex;
            },
            handleReset(clearFilters) {
                clearFilters();
                this.searchText = '';
            },
            handleConfirm(data) {
                this.showConfirmModal = true;
                this.currentRequest = data;
            },
            handleCancelRequest() {
                this.showConfirmModal = false;
                this.currentRequest = {};
                this.reasons = "";
            },
             confirmAction() {
                this.showConfirmModal = false;
                this.confirmActionModal = true;
            },
            cancelAction() {
                this.confirmActionModal = false;
            },

            onInventoryChange(value, clearFilters){
                let result = []
                if(value === 'all'){
                    result = this.availableTransfers
                }else {
                    result = this.availableTransfers.filter(invoice => parseInt(invoice.status) === parseInt(value) )
                }
                this.tableInventoryTransfers = result.map(transfer => ({
                    key: transfer.id,
                    id: transfer.id,
                    sourceLocationName: transfer.sourceLocationName ? transfer.sourceLocationName : 'N/A',
                    destinationLocationName: transfer.destinationLocationName ? transfer.destinationLocationName : 'N/A',
                    status: transfer.statusLabel ? transfer.statusLabel : 'N/A',
                    createdAt: moment(transfer.createdAt).format('DD-MM-YYYY HH:mm:ss'),
                    action: transfer
                }))
                clearFilters();
            },

            async handleConfirmRequest() {
            this.loading = true;
            const payload = {
                notes: this.reasons,
                InventoryRequestId: this.currentRequest.id,
            };
            try {
                const res = await this.$store.dispatch(
                "distroCenter/ConfirmInventoryRequest",
                payload
                );
                if (res) {
                this.showSuccessAlert("Inventory transfer confirmed");
                this.loading = false;
                this.showConfirmModal = false;
                this.confirmActionModal = false;
                this.getAllInventoryTransferData();
                }
            } catch (error) {
                // console.log("Error=> ", error)
            }
            },
    
            addDomain() {
                this.$refs.addInventoryTransferForm.validate(valid => {
                    if(valid){
                        this.checkExistingProducts()
                        if(this.filteredProducts.length !== 0) {
                            this.addInventoryTransferModel.request.push({
                                productId: '',
                                quantity: '',
                                balance: 0,
                                key: Date.now()
                            });
                            this.scrollToEnd();
                        }
                    }else{
                        return false;
                    }
                })
            },
            scrollToEnd: function() { 
                const container = this.$refs.productHeight;
                container.scrollTop = container.scrollHeight;
            },
            removeDomain(item) {
                let index = this.addInventoryTransferModel.request.indexOf(item);
                if (index !== -1) {
                    this.addInventoryTransferModel.request.splice(index, 1);
                }
                this.checkExistingProducts()
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            showTransfersLines(data){
                // console.log("data | ", data)
                this.setWareHouseTransferLinesInfo(data)
                this.$router.push({
                    name: 'warehouse-transfers-lines',
                    params: { transferId: data.id }
                    }).catch(()=>{})
            },
            onChangeQuantity(request, quantity){
            
                let index = this.addInventoryTransferModel.request.indexOf(request);
                if(index !== -1){
                    let item = this.addInventoryTransferModel.request[index]

                    if(!item.productId){
                        this.showErrorAlert("Kindly select product")
                    }else{
                        if(!(quantity <= item.balance)){
                            this.showErrorAlert(`You've exceeded the quantity. Kindly choose between 1 to ${item.balance}`)
                        }
                    }
                }
            },
            checkExistingProducts(){
                const selectedProducts = this.addInventoryTransferModel.request.map(product => product.productId)
                const products = [];
                this.availableProducts.forEach(product => {
                    if(!(selectedProducts.includes(product.productId))){
                        products.push(product)
                    }
                })
                this.filteredProducts = products
            },
            onChangeProduct(request,productId){
                if(request.productId === productId){
                    const product = this.filteredProducts.find(product => product.productId === productId)
                    if(product){
                        let index = this.addInventoryTransferModel.request.indexOf(request);
                        let item = this.addInventoryTransferModel.request[index]
                        item.balance = product.balance
                        this.addInventoryTransferModel.request[index] = item
                    }
                }
            },
            async onChangeSourceLocation(id){
                this.loading = true
                const request = {
                    locationId: id
                }
                const response = await this.getInventoryBalByDistCenter(request)
                
                this.loading = false
                if(response.status === 200){
                    this.availableProducts = response.data.filter(product => product.balance >  0)
                    this.filteredProducts = response.data.filter(product => product.balance >  0)
                    this.addInventoryTransferModel.request = []
                    this.addInventoryTransferModel.request.push({
                            productId:'',
                            quantity: '',
                            balance: 0,
                            key: Date.now()
                        })
                    
                }else{
                    // console.log("Error | ", response)
                }
            },
            exportStockData(){
                const dataToExport = [
                    [
                        "Product Name",
                        "Quantity",
                        "Type",
                        "Distribution Center",
                        "Approved By",
                        "Approved At",
                        "Status",
                        "Date Cretaed"
                    ],
                ];
                this.tableInventoryTransfers.forEach((v) => {
                    dataToExport.push([
                        v.productName,
                        v.quantity,
                        v.typeLabel,
                        v.locationName,
                        v.approvedByName,
                        v.approvedAt,
                        v.status,
                        v.createdAt
                    ]);
                });

                var wb = XLSX.utils.book_new();
                var ws = XLSX.utils.aoa_to_sheet(dataToExport);

                /* Add the worksheet to the workbook */
                XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

                /* generate file and send to client */
                XLSX.writeFile(wb, `Export-Stock-Adjustment-${moment().format('DD-MM-YYYY')}.xlsx`);
                this.showSuccessAlert("Data Successfully Exported")
            },
           
            showAddInventoryTransferModal(){
                this.addInventoryTransferVisible = true;
            },
            handleChangePasswordCancel(){
                this.changePasswordVisible = false
            },
            handleAddInventoryTransferCancel() {
                // console.log('Clicked cancel button');
                this.addInventoryTransferVisible = false;
            },
        
            handleAddInventoryTransfer(){
                this.$refs.addInventoryTransferForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        let productQuantity = {};

                        this.addInventoryTransferModel.request.forEach(product => {
                            productQuantity[product.productId] = product.quantity
                        })
                        const request = {
                            
                            destinationLocationId: this.addInventoryTransferModel.distributionCenterId,
                            data: {
                                sourceLocationId: this.addInventoryTransferModel.sourceLocationId,
                                items: productQuantity,
                                notes: this.addInventoryTransferModel.notes 
                            }                  
                        }

                        this.addInventoryTransfer(request).then(response => {
                            
                            this.loading = false;
                            if(response.status === 200){
                                // this.loadBackOrdersData();
                                this.showSuccessAlert("New Inventory Tranfer Created Successfully")
                                this.$refs.addInventoryTransferForm.resetFields();
                                this.addInventoryTransferModel.request = []
                                this.addInventoryTransferModel.request.push({
                                        productId:'',
                                        quantity: '',
                                        balance: 0,
                                        key: Date.now()
                                })
                                this.addInventoryTransferVisible = false;
                            }else{
                                this.showErrorAlert(response.data.messages)
                            }
                        },
                        error =>{
                            this.loading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })                    
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
            },

            async loadAllDistributionCenters(){
                const response = await this.getAllDistributionCenters()
                if(response.status === 200){
                    
                    this.availableDistCenters = await response.data.data
                    // console.log("availableDistCenters | ", this.availableDistCenters)
                }else{
                console.log("Error 2| " , response)
                }
            },
            async getAllInventoryTransferData(){
                this.tableLoading = true;
        
                const response =  await this.getWareHousTransferData('')
                this.tableLoading = false;
                if(response.status === 200){
                    this.availableTransfers = response.data.data
                    this.tableInventoryTransfers = response.data.data.map(transfer => ({
                        key: transfer.id,
                        id: transfer.id,
                        sourceLocationName: transfer.sourceLocationName ? transfer.sourceLocationName : 'N/A',
                        destinationLocationName: transfer.destinationLocationName ? transfer.destinationLocationName : 'N/A',
                        status: transfer.statusLabel ? transfer.statusLabel : 'N/A',
                        createdAt: moment(transfer.createdAt).format('DD-MM-YYYY HH:mm:ss'),
                        action: transfer
                    }))
                }else{
                    console.log("Error | ",response)
                }
            },
            async loadClientAndDistCenters(){
                const response = await this.getClientProductAndDistCenters(this.params)
                
                this.getClientProducts(response[0])
                this.getAllDistributionCenters(response[1])
            }

        },
        created() {
          
          if(this.getAllInventoryTransferData){
              this.getAllInventoryTransferData();
          }
          if(this.loadAllDistributionCenters){
              this.loadAllDistributionCenters()
          }
        }
    }
</script>

<style scoped>

.actions{
    display: flex;
    justify-content: space-between;
}
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}
.tableStyle >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle >>> .ant-pagination-item-active a {
    color: #fff;
}
.tableStyle >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
a {
  color: #418a49;
}
a:hover{
  color: #418a49;
}

.rightSideinputText{
    width: 100%;
    border-radius: 5px;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}

</style>